import URLSearchParams from "./classes/URLSearchParams.mjs";
import FormData from "./classes/FormData.mjs";
import Blob from "./classes/Blob.mjs";
const platform = {
  isBrowser: true,
  classes: {
    URLSearchParams,
    FormData,
    Blob
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
export {
  platform as default
};
